/***
 * Created on 2024/5/13
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {useTranslation} from "react-i18next";
import {SUPPORTED_LANGUAGES} from "../../../service/common";
import {useBoundedStore} from "../../../lib/store";

function LangLevePanel({toggleLang}) {
    const { t, i18n } = useTranslation();
    const store = useBoundedStore();

    const onLanguageChange = (value) => {
        i18n.changeLanguage(value);
        store.setLanguage(value);
    }

    return (
         <div className="multi-level-sheet-content__panel">
              <div className="sheet-content">
                  <ul className="sheet-list">
                      <li className="sheet-list__navbar">
                          <div className="sheet-list__navbar__back" onClick={()=>toggleLang(prev=> prev==='close' ? 'open' : 'close')}>
                              <div className="sheet-list__navbar__arrow"></div>
                              <div className="sheet-list__navbar__label">{t('@Back@')}</div>
                          </div>
                      </li>

                      <li className="sheet-list__section">
                          <ul>
                              {SUPPORTED_LANGUAGES.map(lang =>
                                  <li className="sheet-list__item display-flex align-items-center cursor-pointer" key={lang.value}>
                                      <span className="flex-1 min-w-0" onClick={() => onLanguageChange(lang.value)}>{lang.name}</span>
                                      {
                                          lang.value === i18n.language &&
                                          <span className="sheet-list__item__mark--checked flex-initial"></span>
                                      }
                                  </li>)
                              }
                          </ul>
                      </li>
                  </ul>
              </div>
         </div>
    );
}

export default LangLevePanel;